module.exports = __webpack_public_path__ + "static/hero-border-gray-c58f2a65c8744c76a8e9f2f663996356.svg";